/**
 * Suppress specific React warnings that are not critical
 * This helps clean up console output for development
 */

// Store original console.warn
const originalWarn = console.warn;

// Override console.warn to filter out specific warnings
console.warn = (...args) => {
  const message = args[0];
  
  // Suppress specific warnings that are not critical
  if (typeof message === 'string') {
    // Suppress Fade timeout warning
    if (
      message.includes('timeout') && 
      message.includes('Fade') && 
      (message.includes('Failed prop type') || message.includes('required'))
    ) {
      return;
    }
    
    // Suppress other known non-critical warnings
    if (message.includes('componentWillReceiveProps has been renamed')) {
      return;
    }
    
    if (message.includes('componentWillMount has been renamed')) {
      return;
    }
  }
  
  // Allow all other warnings to pass through
  originalWarn.apply(console, args);
};

export default {};
